import React from 'react'
import PropTypes from 'prop-types'

import { StyledContainer, StyledValue, StyledLabel } from './styles'

export const Statistic = ({ value, label, theme }) => {
  return (
    <StyledContainer>
      <StyledValue theme={theme}>{value}</StyledValue>
      <StyledLabel theme={theme}>{label}</StyledLabel>
    </StyledContainer>
  )
}

Statistic.defaultProps = {
  value: 0,
  label: '',
  theme: 'default',
}

Statistic.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  theme: PropTypes.string,
}
